import Joi from '@hapi/joi'

export const employeeCardUploadSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Please Select the Valid Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid().required().label("Division Name").messages({
        "any.invalid": `Please Select the Valid Division`,
        "any.required": `Division required`
    }),
    collectionCategoryID: Joi.number().invalid().required().label("Collection Catagory").messages({
        "any.invalid": `Please Select the Valid Collection Catagory`,
        "any.required": `Collection Catagory required`
    }),
    isRsm: Joi.boolean().label("Is Rsm")
}